import axios from "axios";
import { Message, Loading } from 'element-ui';

let loading

// loading开始 方法
function startLoading() {
    // element-ui loading 服务调用方式  
    loading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
    })
}
 // loading结束 方法
 function endLoading() {  
    loading.close()
}
export function request(tt) {
    const install = axios.create({
        baseURL: '',
        timeout: 20000
    })
    install.interceptors.request.use(resquest => {
        startLoading();
        // console.log("请求拦截",resquest);
        return resquest
    })
    install.interceptors.response.use(response => {
        // console.log("响应拦截",response);
        // endLoading()
        setTimeout(() => {
            endLoading()
        }, 200);
        return response.data
    })
    return install(tt)
}
export const baseURL = ""